<template>
  <modal class="filters-modal--leads" :is-opened="isOpened" :on-close="onClose">
    <template #header>
      <div class="filters-modal__header">
        {{ trans('modal.filters.title') }}
      </div>
    </template>
    <template #body>
      <div>
        <div class="filters-modal__filters">
          <InputSearch
            class="modal-state__input-search"
            :placeholder="trans('user.inbox.searchbar.placeholder')"
            @search-input="onSearchInput"
          />
          <AddressFilter class="modal-state__address-filter" />
        </div>
        <div class="filters-modal__actions">
          <button class="btn btn--primary" @click="onClose">
            {{ trans('modal.filters.button') }}
          </button>
        </div>
      </div>
    </template>
  </modal>
</template>

<script>
import InputSearch from '@components/InputSearch.vue';
import Modal from '@components/Modal.vue';
import AddressFilter from '@components-molecules/AddressFilter.vue';
import { storeToRefs } from 'pinia';
import { useAddressFilterStore } from '@stores/useAddressFilterStore';
import { translationMixin } from '@elements/translation';
import { eventBus } from '@tools/event-bus';

export default {
  components: { AddressFilter, InputSearch, Modal },
  mixins: [ translationMixin ],
  props: {
    isOpened: { type: Boolean, default: true },
    archiveLink: { type: String, default: '' },
    modelValue: { type: String, default: '' },
  },
  emits: [ 'update:modelValue', 'close' ],
  setup() {
    const { selectedAddressesIds } = storeToRefs(useAddressFilterStore());
    return {
      selectedAddressesIds,
    };
  },
  computed: {
    search: {
      get() {
        return this.modelValue;
      },
      set(search) {
        this.$emit('update:modelValue', search);
      },
    },
  },
  mounted() {
    if (document.querySelector('.filters-modal .modal-container')) {
      document
        .querySelector('.filters-modal .modal-container')
        .addEventListener('click', () => {
          eventBus.dispatchEvent(new Event('filters-modal-click-outside'));
        });
    }
  },
  methods: {
    onSearchInput(data) {
      if (typeof data === 'string') {
        this.search = data;
      }
    },
    onClose() {
      this.$emit('close');
    },
  },
};
</script>
